import React from "react";
import { Link } from "react-router-dom";
import { GoHome } from "react-icons/go";
import { FiChevronRight } from "react-icons/fi";
function Breadcrumb({ title }) {
  return (
    <div className="bg-slate-100 py-10">
      <div className="flex items-center justify-start container mx-auto space-x-5">
        <GoHome className="h-5 w-5 text-gray-400" />
        <FiChevronRight className="h-5 w-5 text-gray-400" />
        <a href="#" to={"/"} className="text-primary">
          {title}
        </a>
      </div>
    </div>
  );
}

export default Breadcrumb;
